type SvgProps = React.SVGProps<SVGSVGElement>;
export const GroupByIcon = (props: SvgProps) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clip-path="url(#clip0_6838_2225)">
        <path
          d="M4.25 11.75V13H3.5C3.36739 13 3.24021 12.9473 3.14645 12.8535C3.05268 12.7598 3 12.6326 3 12.5V11.75H4.25ZM5.25 10.75H2V12.5C2 12.8978 2.15804 13.2793 2.43934 13.5607C2.72064 13.842 3.10218 14 3.5 14H5.25V10.75Z"
          fill="#706A85"
        />
        <path
          d="M13 11.75V12.5C13 12.6326 12.9473 12.7598 12.8535 12.8535C12.7598 12.9473 12.6326 13 12.5 13H11.75V11.75H13ZM14 10.75H10.75V14H12.5C12.8978 14 13.2793 13.842 13.5607 13.5607C13.842 13.2793 14 12.8978 14 12.5V10.75Z"
          fill="#706A85"
        />
        <path
          d="M4.25 7.375V8.625H3V7.375H4.25ZM5.25 6.375H2V9.62499H5.25V6.375Z"
          fill="#706A85"
        />
        <path
          d="M13 7.375V8.625H11.75V7.375H13ZM14 6.375H10.75V9.62499H14V6.375Z"
          fill="#706A85"
        />
        <path
          d="M4.25 3V4.25H3V3.5C3 3.36739 3.05268 3.24021 3.14645 3.14645C3.24021 3.05268 3.36739 3 3.5 3H4.25ZM5.25 2H3.5C3.10218 2 2.72064 2.15804 2.43934 2.43934C2.15804 2.72064 2 3.10218 2 3.5V5.25H5.25V2Z"
          fill="#706A85"
        />
        <path
          d="M8.625 11.75V13H7.375V11.75H8.625ZM9.62499 10.75H6.375V14H9.62499V10.75Z"
          fill="#706A85"
        />
        <path
          d="M8.625 7.375V8.625H7.375V7.375H8.625ZM9.62499 6.375H6.375V9.62499H9.62499V6.375Z"
          fill="#706A85"
        />
        <path
          d="M8.625 3V4.25H7.375V3H8.625ZM9.62499 2H6.375V5.25H9.62499V2Z"
          fill="#706A85"
        />
        <path
          d="M12.5 3C12.6326 3 12.7598 3.05268 12.8535 3.14645C12.9473 3.24021 13 3.36739 13 3.5V4.25H11.75V3H12.5ZM12.5 2H10.75V5.25H14V3.5C14 3.10218 13.842 2.72064 13.5607 2.43934C13.2793 2.15804 12.8978 2 12.5 2V2Z"
          fill="#706A85"
        />
      </g>
      <defs>
        <clipPath id="clip0_6838_2225">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(2 2)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
